import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const initiativeImporterSelectors = importerSelectors(
  'initiative.importer',
);

export default initiativeImporterSelectors;
